import { render, staticRenderFns } from "./ShowDetailCajaField.vue?vue&type=template&id=594c6acc&scoped=true&"
import script from "./ShowDetailCajaField.vue?vue&type=script&lang=js&"
export * from "./ShowDetailCajaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c6acc",
  null
  
)

export default component.exports